import { loader } from 'graphql.macro'

export default async function exportJobs ({ dataLoaders, variables }) {
  const schema = loader('./exportJobs.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      haulerId: variables.haulerId,
      searchFields: variables.searchFields,
      sortColumn: variables.sortColumn,
      sortDirection: variables.sortDirection
    }
  })
  return response.exportJobsSearch
}
